/**
 * Workflow Builder Page
 *
 * AI-native visual workflow designer for crypto exchange compliance.
 */

import React from 'react';
import { WorkflowBuilderPage as WorkflowBuilderPageComponent } from '../workflow-builder';

export default function WorkflowBuilderPage() {
  return <WorkflowBuilderPageComponent />;
}
